import * as React from 'react';
import WeddingSpaces, { WeddingSpacesData } from './WeddingSpaces';
import FloorPlans, { FloorPlansData } from './FloorPlans';
import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

export interface SocialTablesData extends WeddingSpacesData, FloorPlansData {}

interface Props {
    venueId?: number;
    csnVenueData?: SocialTablesData;
    onSectionExpanded: (name: string) => void;
}

const SocialTables = (props: Props) => {
    const { ref, inView, entry } = useInView({
        threshold: 0.1,
    });
    const [socialTableLogged, setSocialTablesLogged] = useState(false);

    useEffect(() => {
        if (!socialTableLogged && inView && entry?.target?.clientHeight) {
            logEvent(AnalyticsEvent.EVTNM_VISITED_SOCIAL_TABLES, {
                Source: 'Wedding venue profile',
                'Venue ID': props.venueId,
            });
            setSocialTablesLogged(true);
        }
    }, [inView]);

    return (
        <div ref={ref}>
            <WeddingSpaces csnVenueData={props.csnVenueData} onSectionExpanded={props.onSectionExpanded} />
            <FloorPlans venueId={props.venueId} csnVenueData={props.csnVenueData} onSectionExpanded={props.onSectionExpanded} />
        </div>
    );
};

export default SocialTables;
